import { render } from "./IsoBookingButtonForm.vue?vue&type=template&id=35efa228"
import script from "./IsoBookingButtonForm.vue?vue&type=script&lang=js"
export * from "./IsoBookingButtonForm.vue?vue&type=script&lang=js"
script.render = render

export default script